import { Spinner } from "@blueprintjs/core"
import styled from "styled-components"

const Container = styled.div`
  height: 100%;
  padding-top: 200px;
  text-align: center;
`

interface ILoadingIndicator {
  text?: string
  spinnerSize?: number
}

/**
 * A functional component that shows a loading spinner with a customizable message
 * Props:
 * - text: The message to display (defaults to "Loading...")
 * - spinnerSize: The size of the spinner (defaults to 25)
 */
const LoadingIndicator = ({
  text = "Loading...",
  spinnerSize = 25,
}: ILoadingIndicator) => {
  return (
    <Container>
      <Spinner size={spinnerSize} />
      {text}
    </Container>
  )
}

export default LoadingIndicator
